import React, { useLayoutEffect } from 'react';
import { CSSTransition } from 'react-transition-group';
import { Route, useRouteMatch } from 'react-router-dom';
import { Container, Typography } from 'amphitheatre';

import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';
import Step5 from './Step5';

import Video1 from './Video1';
import Video2 from './Video2';
import Video3 from './Video3';

import data from './tutorials.json';
import Tutorial from '../../Tutorial';
import { Wrapper } from './Tutorials.styled';

const { Header } = Typography;
const { oldVids, tutorials } = data;

const Default: React.FunctionComponent = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container className="anim-container" size="lg">
      <Header>P.I.G.I Overview</Header>
      {oldVids.map((vid) => (
        <Tutorial key={vid.id} {...vid} url={`/tutorials${vid.url}`} />
      ))}
      <br />
      <Header level={2}>Further Readings</Header>
      {tutorials.map((tutorial) => (
        <Tutorial
          key={tutorial.id}
          {...tutorial}
          url={`/tutorials${tutorial.url}`}
        />
      ))}
    </Container>
  );
};

const routes = [
  { path: '/', Component: Default },
  { path: '/step1', Component: Step1 },
  { path: '/step2', Component: Step2 },
  { path: '/step3', Component: Step3 },
  { path: '/step4', Component: Step4 },
  { path: '/step5', Component: Step5 },
  { path: '/video1', Component: Video1 },
  { path: '/video2', Component: Video2 },
  { path: '/video3', Component: Video3 },
];

const Tutorials: React.FunctionComponent = () => {
  const match = useRouteMatch();

  return (
    <Wrapper>
      {routes.map(({ path, Component }) => (
        <Route key={path} exact path={`${match.url}${path}`}>
          {({ match }) => (
            <CSSTransition
              in={match !== null}
              timeout={500}
              classNames="page"
              unmountOnExit
            >
              <Component />
            </CSSTransition>
          )}
        </Route>
      ))}
    </Wrapper>
  );
};

export default Tutorials;
